export default __webpack_public_path__ + "static/media/estimate-mobile.c8688113.mp4";